export const customers = {
    title: "কাস্টমার",
    description: "অনলাইনে বা দোকানে যারা কেনেন, সবাই — ফোন নম্বর দিয়ে খুঁজুন।",
    new: "নতুন কাস্টমার",
    search: "নাম বা ফোন দিয়ে খুঁজুন",
    tag: "ট্যাগ",
    group: "গ্রুপ",
    dueOnly: "শুধু বকেয়া আছে এমন কাস্টমার",
    columns: { name: "নাম", phone: "ফোন", tags: "ট্যাগ", balance: "বকেয়া", limit: "বাকির সীমা" },
    empty: "এখনও কোনো কাস্টমার নেই।",
    back: "সব কাস্টমার",
    due: "বকেয়া",
    advance: "অগ্রিম জমা",
    creditLimit: "বাকির সীমা",
    noCredit: "বাকিতে বিক্রি নেই (সীমা ০)",
    conflict: "অন্য কেউ এই কাস্টমার বদলেছেন। সর্বশেষ সংস্করণ দেখানো হচ্ছে; আবার চেষ্টা করুন।",
    form: {
        titleNew: "নতুন কাস্টমার",
        titleEdit: "কাস্টমার সম্পাদনা",
        name: "নাম",
        phone: "মোবাইল নম্বর",
        altPhone: "দ্বিতীয় মোবাইল নম্বর",
        email: "ইমেইল",
        tags: "ট্যাগ (কমা দিয়ে আলাদা)",
        groups: "গ্রুপ (কমা দিয়ে আলাদা)",
        note: "নোট",
        creditLimit: "বাকির সীমা",
        creditLimitHint: "বাকিতে বিক্রি থেকে এই কাস্টমার সর্বোচ্চ কত দেনা রাখতে পারবেন। ০ = বাকি নেই।",
        openingDue: "আগের বকেয়া (প্রারম্ভিক)",
        openingDueHint: "সিস্টেম ব্যবহারের আগে এই কাস্টমারের যা বকেয়া ছিল। একবারই দেওয়া যায়।",
        save: "কাস্টমার সংরক্ষণ",
        phoneTaken: "এই নম্বরে আরেকজন কাস্টমার আছেন। তাকে খুঁজে নিন।",
    },
    created: "কাস্টমার যোগ হয়েছে।",
    saved: "কাস্টমার সংরক্ষিত হয়েছে।",
    edit: "সম্পাদনা",
    addresses: {
        title: "ঠিকানা",
        add: "ঠিকানা যোগ করুন",
        edit: "সম্পাদনা",
        remove: "মুছুন",
        removed: "ঠিকানা মোছা হয়েছে।",
        saved: "ঠিকানা সংরক্ষিত হয়েছে।",
        empty: "এখনও কোনো ঠিকানা নেই।",
        label: "নাম (বাসা, অফিস…)",
        recipient: "প্রাপক (অন্য কেউ হলে)",
        phone: "এই ঠিকানার ফোন",
        division: "বিভাগ",
        district: "জেলা",
        upazila: "উপজেলা / থানা",
        line: "বাড়ি, রোড, এলাকা",
        isDefault: "প্রধান ঠিকানা",
        default: "প্রধান",
        save: "ঠিকানা সংরক্ষণ",
        cancel: "বাতিল",
    },
    ledger: {
        title: "বকেয়া",
        empty: "এখনও কোনো বকেয়া এন্ট্রি নেই।",
        columns: { date: "তারিখ", entry: "বিবরণ", amount: "পরিমাণ", balance: "পরে বকেয়া" },
        types: {
            opening: "প্রারম্ভিক বকেয়া",
            credit_sale: "বাকিতে বিক্রি",
            sale_return: "ফেরত",
            payment: "পরিশোধ",
            adjustment: "সমন্বয়",
            reversal: "বাতিল",
            merge_in: "একত্রীকরণে এসেছে",
            merge_out: "একত্রীকরণে গেছে",
        },
        reversedLabel: "বাতিল হয়েছে",
        payment: "টাকা গ্রহণ",
        amount: "পরিমাণ",
        method: "মাধ্যম",
        reference: "রেফারেন্স (TrxID)",
        note: "নোট",
        savePayment: "পরিশোধ সংরক্ষণ",
        paid: "পরিশোধ সংরক্ষিত হয়েছে।",
        adjust: "বকেয়া সমন্বয়",
        adjustAmount: "পরিবর্তন (+ বেশি দেনা, − কম দেনা)",
        adjustNote: "কেন?",
        saveAdjustment: "সমন্বয় সংরক্ষণ",
        adjusted: "বকেয়া সমন্বয় হয়েছে।",
        reverse: "বাতিল করুন",
        reverseNote: "কেন বাতিল?",
        reversed: "এন্ট্রি বাতিল হয়েছে।",
        methods: {
            cash: "নগদ",
            card: "কার্ড",
            bkash: "বিকাশ",
            nagad: "নগদ (মোবাইল)",
            rocket: "রকেট",
            bank_transfer: "ব্যাংক ট্রান্সফার",
            other: "অন্যান্য",
        },
    },
    statement: {
        title: "হিসাব বিবরণী",
        from: "থেকে",
        to: "পর্যন্ত",
        make: "PDF তৈরি করুন",
    },
    reminder: {
        send: "SMS রিমাইন্ডার পাঠান",
        sent: "রিমাইন্ডার পাঠানোর জন্য রাখা হয়েছে।",
        sendAll: "বকেয়া আছে এমন সবাইকে মনে করিয়ে দিন",
        sentAll: "বকেয়া আছে এমন কাস্টমারদের রিমাইন্ডার পাঠানো হচ্ছে।",
    },
    merge: {
        title: "অন্য কাস্টমারের সাথে একত্র করুন",
        description: "একই মানুষ দুবার যোগ হলে এটি ব্যবহার করুন। এই কাস্টমারের ঠিকানা, বকেয়া ও অর্ডার আপনার বাছাই করা জনের কাছে যাবে; এই রেকর্ডটি থাকবে না।",
        search: "যাকে রাখবেন তাকে খুঁজুন",
        confirm: "{{name}}-এর সাথে একত্র করুন",
        done: "কাস্টমার একত্র হয়েছে।",
        open: "একত্র করুন…",
    },
};
//# sourceMappingURL=customers.js.map